// THIS MARKER IS CURRENTLY NOT USED BUT WILL BE REINTRODUCED IN FUTURE WITH GOVERNMENT TIE-INS etc
import { displayLatLonInCompassFormat } from '@deckee/utilities';
import { lifeRing } from '../../../components/shared/vector-images';
import {
  onInitializeStandardMarker,
  onToggleStandardMarker,
} from '../_helpers';

const layer = {
  displayName: 'Need help',
  synonyms: '',
  group: 'standardMarker',
  typeUrl: 'need-help',
  icon: {
    baseShape: lifeRing,
    iconColor: '#fff',
    markerColor: '#B01515',
  },
  shownByDefault: true,
  relativeDepth: 0,
  menuOptions: {
    visible: true,
    owningMenu: 'important-alerts',
    order: 1000,
  },
  standardMarkerOptions: {
    markerType: 'needHelpMarker',
    allowCreation: false,
    allowEditing: false,
    allowComments: true,
    viewOptions: {
      typeTitle: 'Need help',
      itemTitleFunction: () => 'Need help',
    },
    creationOptions: {
      menuText: 'Need help',
      newTitle: 'Need help',
      titlePlaceholder: 'Title',
      markerTypeDescription: 'Share any other helpful information here...',
      checkBoxItems: [],
    },
    editingOptions: {},
  },
  popOverConfiguration: (marker) => ({
    markerType: marker.markerType,
    id: marker.id,
    displayChat: true,
    displayUpVotes: true,
    title: 'Need help',
    description: displayLatLonInCompassFormat(marker.latLon),
  }),
};

layer.onInitialize = onInitializeStandardMarker(layer);
layer.onToggle = onToggleStandardMarker(layer);

export default layer;
